import axios from "axios"
import { CONST_API_AI_ADMIN_GET_USAGE_ENDPOINT, CONST_API_AI_ADMIN_PUT_USER_QUOTA_ENDPOINT } from "../../endpoints"
import { AiGlobalStats, Top3User, UserQuota } from "./types/ai-dashboard"

export interface GetAiUsageResponse {
     stats: AiGlobalStats
     top3: Top3User[]
     users: UserQuota[]
     total: number
     perPage: number
}

export type AlertFilter = "all" | "daily" | "monthly"

export function getAiUsageRequest(
     search: string,
     page: number,
     filter: AlertFilter,
     startDate?: string, // Added
     endDate?: string // Added
) {
     return axios.get<GetAiUsageResponse>(CONST_API_AI_ADMIN_GET_USAGE_ENDPOINT, {
          params: {
               search: search || undefined,
               page,
               filter: filter !== "all" ? filter : undefined,
               startDate,
               endDate,
          },
     })
}

export interface SetUserQuotaPayload {
     isUnlimited: boolean
     dailyLimit?: number
     monthlyLimit?: number
}

export function setUserAiQuotaRequest(userId: number, payload: SetUserQuotaPayload) {
     return axios.put<{ id: number; dailyLimit: number | null; monthlyLimit: number | null }>(
          CONST_API_AI_ADMIN_PUT_USER_QUOTA_ENDPOINT(userId),
          payload
     )
}
